import { Container } from "./styles";
import { useState } from "react";
import logoIcon from "../../../../../../assets/Logo icon.svg";
import image1 from '../../../../../../assets/home/patrimonio.svg';
import image2 from '../../../../../../assets/home/CurrencyDollar.svg';
import { useTitleAndUser } from '../../../../../../hooks/userTitle';
import { useActives } from '../../../../../../hooks/useActives';


interface Props {
  totalInvestment: number;
  totalInvestmentWithoutReserve: number;
  boxesTotalApplied: number;
  boxesCount: number;
  disabled?: boolean;
  emergencyReserve: number; //reserva do box
  onClick?: () => void;
}

export function MyGoalsBoxCard({
  totalInvestment,
  totalInvestmentWithoutReserve,
  boxesTotalApplied,
  boxesCount,
  disabled,
  emergencyReserve, //reserva do box
  onClick,
}: Props) {
  const noEmergency = (boxesTotalApplied - emergencyReserve)
  const percentual =
    (noEmergency > 0 && totalInvestment > 0)
      ? ((noEmergency) / totalInvestment) * 100
      : 0;

  const { showActive } = useActives() as any;

  // @ts-ignore
  const { permissions } = useTitleAndUser();

  const isAdmin = permissions.includes('Admin');
  const isPaidUser =
    permissions.includes('General') || permissions.includes('IRPF');
  const isFreeUser =
    permissions.includes('Grátis') || permissions.includes('Trial');

  const isBlocked = !isAdmin && !isPaidUser && isFreeUser;
  const canViewData = showActive && (isAdmin || isPaidUser);

  const renderCurrency = (value: number) => {
    if (!canViewData) return 'R$ *******';

    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };



  return (
    <Container
      title={
        isBlocked
          ? 'Você precisa ter uma assinatura para visualizar os dados'
          : undefined
      }
    >
      <div
        onClick={() => {
          if (disabled) return;
          onClick?.();
        }}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
        className="card-patrimonio"
      >
        <div className="top">
          <div style={{
            display:'flex',
            flexDirection:'column',
            justifyContent: 'flex-start',
          }}>
            <div style={{display:'flex', flexDirection:'row', width:'298px',}}>
              <span className="title">Patrimônio total</span>
              <img
                src={image1}
                alt={'title'}
                style={{ width: '20px', height: '20px', position:'absolute', marginLeft:'25%',}}
              />
            </div>
            <strong className={isBlocked ? 'blocked' : ''}>
              {renderCurrency(totalInvestment)}
            </strong>

            {/* <strong>{totalInvestment.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}</strong> */}
          </div>
          <div className="divider-vertical" />
          <div style={{
            display:'flex',
            flexDirection:'column',
            justifyContent: 'flex-start',
            width:'184px',
            marginLeft: '22px',
          }}>
            <span className="title">Carteira de investimentos</span>
            <img
                src={image2}
                alt={'title'}
                style={{ width: '20px', height: '20px', position:'absolute', marginLeft:'25%',}}
              />

            <strong className={isBlocked ? 'blocked' : ''}>
              {renderCurrency(totalInvestmentWithoutReserve)}
            </strong>

            {/* <strong>{totalInvestmentWithoutReserve.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}</strong> */}
          </div>
        </div>

        <div className="divider" />

        <div className="bottom">
          <img src={logoIcon} alt="iBox" width={'24px'} height={'24px'} className="image"/>
          <div className="bottom-left">
            <span className="label">
              Box objetivos:
            </span>
            <div style={{
              display:'flex',
              flexDirection:'row',
              gap:'8px',
            }}>
              <span className="value">
                {renderCurrency(noEmergency)}
              </span>

              {/* <span className="value">
                {noEmergency.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </span> */}
              <small className="percentual">
                {canViewData ? `(${percentual.toFixed(1)}%)` : '(*)'}
              </small>

              {/* <small className="percentual">
                ({percentual.toFixed(1)}%)
              </small>      */}

              {/* <small className="count">
                Você tem {boxesCount} boxes em renda fixa
              </small> */}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
